import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService {
  private mainWidth: number;
  private mainHeight: number;

  initScreenSize() {
    const MAX_RATIO = .66;
    const height = document.documentElement.clientHeight;
    let width = document.documentElement.clientWidth;

    if (window.innerWidth / window.innerHeight > MAX_RATIO) {
      width = Math.floor(window.innerHeight * MAX_RATIO);
    }

    this.mainWidth = width;
    this.mainHeight = height;
  }

  get appWidth() {
    return this.mainWidth;
  }

  get appWidthPx() {
    return this.appWidth + 'px';
  }

  get appHeight() {
    return this.mainHeight;
  }

  get appHeightPx() {
    return this.appHeight + 'px';
  }

  get clientRatio() {
    return this.appWidth / this.appHeight;
  }

}
